/* global $, wpcf7 */

import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import Accordion from './Accordion';
import Marquee from './Marquee';
barba.use(barbaPrefetch);

// import Swiper, { Pagination } from "swiper";
import PageHome from './PageHome';
import PageOther from './PageOther';

class Router {
  constructor(mainApp) {
    this.mainApp = mainApp;
    this.currentNamespace = '';
    this.pageApp = undefined;
    this.isFirstAccess = true;
    this.marqueeObjects = [];
    this.onCompleteRouting = true;

    /*
    $(document).on("click", ".js-add-tag", (e) => {
      this.go($(e.currentTarget).attr("href"));
      return false;
    });
    */

    barba.init({
      timeout: 6000,
      debug: false,
      transitions: [
        {
          name: 'default',
          beforeOnce: () => {},
          once: (data) => {
            this.currentNamespace = data['next']['namespace'];
          },
          afterOnce: (data) => {
            this.checkPageApp(data);
            // this.mainApp.initPageApp(this.currentNamespace);
            this.mainApp.transition.init();
          },
          before: async (data) => {
            clearTimeout(this.fadeinTimer);
            this.mainApp.destroyPageApp();

            if (
              this.currentNamespace.indexOf('cases-archive') != -1 &&
              ($(data.trigger).hasClass('js-add-tag') ||
                $(data.trigger).hasClass('js-add-category'))
            ) {
              // ローディング表示しない
            } else {
              this.mainApp.transition.fadein();
              $('.wrapper').removeClass('wrapper--fadein');
            }

            if (this.marqueeObjects.length > 0) {
              for (let i = 0; i < this.marqueeObjects.length; i++) {
                this.marqueeObjects[i].destroy();
                this.marqueeObjects[i] = null;
              }
              this.marqueeObjects = [];
            }
            this.mainApp.spMenu.close();
            // this.mainApp.destroy();
            let waitDuration = 0;
            if (this.pageApp != undefined) {
              this.pageApp.destroy();
              this.pageApp = null;
              this.pageApp = undefined;
            }

            await new Promise((resolve) => {
              return setTimeout(resolve, waitDuration);
            });
          },
          leave: () => {
            // console.log('leave');
          },
          enter: (data) => {
            // console.log('enter');
            window.scrollTo(0, 0);
            this.checkPageApp(data);
            this.mainApp.transition.fadeout();

            // GTM に PV イベントを送る
            if (
              window.ga &&
              typeof window.ga === 'function' &&
              barba.history.h.length >= 1
            ) {
              window.ga('gtm2.send', 'pageview', location.pathname);
            }

            /*
          setTimeout(() => {
            this.mainApp.initPageApp(this.currentNamespace);
          }, 50);
          */

            this.currentNamespace = data['next']['namespace'];
          },
        },
      ],
    });

    // console.log('barba', barba.getPath());

    /*
    $('body').on('click', '.js-router-force' , (e) => {
      e.preventDefault();
      barba.force('//' + window.host_uri + $(e.currentTarget).attr('href'));
      return false;
    });
    */

    window.appRouter = barba;
  }

  go(target) {
    barba.go(target);
  }

  checkPageApp(data) {
    this.currentNamespace = data.next.namespace;
    $('body').attr('data-namespace', this.currentNamespace);
    if (this.currentNamespace == 'home') {
      this.pageApp = new PageHome();
      $('.Header').addClass('Header--no-bg');
    } else {
      this.pageApp = new PageOther();
      $('.Header').removeClass('Header--no-bg');
    }

    if (this.currentNamespace.indexOf('cases') == -1) {
      $('body').addClass('hide-tags');
    }

    this.mainApp.setPageApp();

    if ($('.Accordion').length) {
      $('.Accordion').each((i, e) => {
        if (!$(e).hasClass('initialized')) {
          new Accordion($(e));
        }
      });
    }

    this.fadeinTimer = setTimeout(() => {
      $('.wrapper').addClass('wrapper--fadein');
    }, 600);

    if ($('.wrapper').find('.Marquee').length) {
      $('.wrapper')
        .find('.Marquee')
        .each((i, e) => {
          this.marqueeObjects.push(new Marquee($(e)));
        });
    }

    this.mainApp.header.setCurrentPosition(this.currentNamespace);

    if (this.isFirstAccess) {
      this.isFirstAccess = false;
    } else {
      if (this.currentNamespace == 'information-contact') {
        if (wpcf7 && typeof wpcf7.init === 'function') {
          /*
          document.querySelectorAll('.wpcf7 > form').forEach(function (form) {
            wpcf7.init(form);
          });
          */
        }
      }
    }

    if ($('.wpcf7-form-control').length) {
      $('.wpcf7-form-control').each((i, e) => {
        if ($(e).hasClass('size-m')) {
          $(e).parent().addClass('size-m');
        }
        if ($(e).hasClass('size-s')) {
          $(e).parent().addClass('size-s');
        }
      });
    }

    setTimeout(() => {
      if ($('.show-limit').length) {
        if ($('.show-limit').find('.Grid__col').length < 28) {
          $('.show-limit + .RelatePosts__link').css('display', 'none');
        }
      }
    }, 200);

    setTimeout(() => {
      let url = barba.url.getHref();
      if (url.indexOf('#') != -1) {
        let hash = url.slice(url.indexOf('#'));
        console.log('hash', hash);

        if ($(hash).length) {
          this.mainApp.scrollPage($(hash).offset()['top']);
        }
      }
    }, 500);
  }
}

export default Router;
